import React from "react";
import logo from '../../assets/images/logo.png';
import blazingcoderslogo from '../../assets/images/blazingcoders.png';
import { Link } from "react-router-dom";
import { ROUTE_BASE_URL } from "../../api/common";
export default function Footer() {
  return (
    <div className="header_application">
      <section className="footer ">
        <div className="footer-top">
          <div className="container">
            <div className="footer-flex-wrap">
              <div className="footer-block g-1">
                <div className="footer-brand">
                  <a href={`https://amasi.org`}>
                  <div className="footer-logo-block">
                    <img
                      //   src="assets/image/6671871c56576c66c413a0d2_amasi_logo 2.png"
                      src={logo}
                      loading="lazy"
                      alt=""
                      className="fooer-logo-image"
                    />
                  </div>
                  </a>
                  <h4 className="footer-brand-text">
                    Association of Minimal Access Surgeons of India
                  </h4>
                  <div className="footer-social">
                    <div className="footer-social-icon">
                      <a
                        href="https://www.facebook.com/amasi.ec"
                        target="_blank"
                        className="footer-social-link w-inline-block"
                      >
                        <div className="w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={16}
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47062 14 5.5 16 5.5H17.5V2.1401C17.1743 2.09685 15.943 2 14.6429 2C11.9284 2 10 3.65686 10 6.69971V9.5H7V13.5H10V22H14V13.5Z"></path>
                          </svg>
                        </div>
                      </a>
                      <a href="#" className="footer-social-link w-inline-block">
                        <div className="w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={16}
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M18.2048 2.25H21.5128L14.2858 10.51L22.7878 21.75H16.1308L10.9168 14.933L4.95084 21.75H1.64084L9.37084 12.915L1.21484 2.25H8.04084L12.7538 8.481L18.2048 2.25ZM17.0438 19.77H18.8768L7.04484 4.126H5.07784L17.0438 19.77Z"></path>
                          </svg>
                        </div>
                      </a>
                      <a href="#" className="footer-social-link w-inline-block">
                        <div className="w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={16}
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z"></path>
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer-block">
                <div className="footer-nav">
                  <h2 className="footer-heading">About AMASI</h2>
                  <div>
                    <a href="https://www.amasi.org/history-of-amasi" className="footer-nav-link">
                      History of AMASI
                    </a>
                    <a href="https://www.amasi.org/privacy-policy" className="footer-nav-link">
                      Privacy Policy
                    </a>
                    <a
                      href="https://www.amasi.org/terms-and-conditions-refund-policy"
                      className="footer-nav-link"
                    >
                      Terms and Conditions / Refund Policy
                    </a>
                  </div>
                </div>
              </div>
              <div className="footer-block">
                <div className="footer-nav">
                  <h2 className="footer-heading">Quick Links</h2>
                  <div>
                    <a
                      href="https://amasi.healthconnectdigital.com/"
                      target="_blank"
                      className="footer-nav-link"
                    >
                      AMASI Membership
                    </a>
                    <a href="https://www.amasi.org/upcoming-events" className="footer-nav-link">
                      AMASI Events
                    </a>
                    <a href="https://www.amasi.org/announcements" className="footer-nav-link">
                      Announcements
                    </a>
                  </div>
                </div>
              </div>
              <div className="footer-block">
                <div className="footer-nav">
                  <h2 className="footer-heading">Academy</h2>
                  <div>
                    <a href="#" className="footer-nav-link">
                      AMASI Webinars
                    </a>
                    <a href="https://www.amasi.org/amasi-video-library" className="footer-nav-link">
                      AMASI Video Library
                    </a>
                    <a href="https://www.amasi.org/photo-gallery" className="footer-nav-link">
                      AMASI Photo Library
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="w-embed w-script"></div>
          <div className="container">
            <div className="footer-bottom-flex">
              <p className="copyright">
                © <span id="copyright-year">2025</span> AMASI . All rights reserved.
              </p>
              <a href="https://www.blazingcoders.com/" className="w-inline-block">
                <div className="powered-by">
                  <p className="copyright text-dark">
                    Designed By
                  </p>
                  <img src={blazingcoderslogo} loading="lazy" alt="" className="image" />
                </div>
              </a>
            </div>
          </div>
        </div >
        <div className="w-embed w-script">{/*  */}</div>
      </section >
    </div >

  );
}